import { Pipe, PipeTransform } from "@angular/core";
import { LogType } from "../api/api";

@Pipe({
  name: "logType",
})
export class LogTypePipe implements PipeTransform {
  transform(value?: number): string {
    if (value == undefined) {
      return "None";
    }
    switch (value as LogType) {
      case LogType.CryptoBuy:
        return "Crypto Buy";
      case LogType.CryptoSell:
        return "Crypto Sell";
      case LogType.CryptoError:
        return "Crypto Error";
      case LogType.MojoPay:
        return "MojoPay";
      case LogType.Start:
        return "Start";
      case LogType.Error:
        return "Error";
      case LogType.Cancel:
        return "Cancel";
      case LogType.Back:
        return "Back";
      case LogType.SelectLanguage:
        return "Select Language";
      case LogType.Next:
        return "Next";
      case LogType.MtnMoney:
        return "Mtn Money";
      case LogType.Orange:
        return "Orange";
      case LogType.Crypto:
        return "Crypto";
      case LogType.IdCard:
        return "Id Card";
      case LogType.Passport:
        return "Passport";
      case LogType.DrivingLicense:
        return "Driving License";
      case LogType.CaptureImage:
        return "Capture Image";
      case LogType.Deposit:
        return "Deposit";
      case LogType.Withdraw:
        return "Withdraw";
      case LogType.SubmitPhoneNumber:
        return "Submit Phone #";
      case LogType.SubmitOtp:
        return "Submit Otp";
      case LogType.ResendOtp:
        return "Resend Otp";
      case LogType.NoteInserted:
        return "Note Inserted";
      case LogType.NoteReturned:
        return "Note Returned";
      case LogType.NoteAccepted:
        return "Note Accepted";
      case LogType.MtnTransfer:
        return "Mtn Transfer";
      case LogType.MtnWithdraw:
        return "Mtn Withdraw";
      case LogType.DeviceError:
        return "Device Error";
      case LogType.WithdrawCancel:
        return "Withdraw Cancel";
    }
    return "None";
  }
}
